<template>
  <v-snackbar
    multi-line
    v-model="unpaidSnackbar"
    :timeout="unpaidSnackbarTimeout"
  >
    {{ unpaidSnackbarText }}
    <v-btn color="blue" text :to="{ name: 'YourOrders' }">View</v-btn>
    <v-btn color="blue darken-2" text @click="unpaidSnackbar = false"
      >Close</v-btn
    >
  </v-snackbar>
</template>

<script>
import axios from "axios";

export default {
  props: {},

  data: () => ({
    unpaidSnackbar: false,
    unpaidSnackbarText:
      "You have Unpaid Orders, to pay or void your unpaid orders go to Orders -> Your Orders",
    unpaidSnackbarTimeout: 5000,
  }),

  async activated() {
    this.checkUnpaid();
  },

  computed: {
    trolly() {
      return this.$store.getters.retrieveCurrentTrolly;
    },
  },

  methods: {
    async checkUnpaid() {
      if (
        this.$store.getters.retrieveIsCncCustomer ||
        this.$store.getters.retrieveIsCashCustomer ||
        this.$store.getters.retrieveIsPaymentCustomer
      ) {
        let payload = {
          userId: this.$store.getters.retrieveUser.userNum,
          sessionKey: this.$store.getters.retrieveUser.sessionKey,
          customerNo : this.$store.getters.retrieveSelectedCustomer,
          daysPast: 90,
          locked: 1,
        };

        console.log("-- Checking Unpaid");
        console.log(payload);
        let stringPayload = JSON.stringify(payload);
        const params = new URLSearchParams();
        params.append("params", stringPayload);

        const response = await axios.post("get-orders", params);

        if (response.data.success == true) {
          if (response.data.orders.length > 0) {
            console.log("-- We have some locked Orders");
            console.log(response.data.orders);
            let showSnackbar = false;

            response.data.orders.forEach((order) => {
              console.log(order);
              if (
                order.locked == 1 &&
                order.payment_found == true &&
                order.payment_success == "0"
              ) {
                //This is a failed Payment
                showSnackbar = true;
              } else if (
                order.locked == 1 &&
                order.payment_found == false &&
                order.payment_success == null
              ) {
                // This is an unpaid order
                showSnackbar = true;
              }
            });

            if (showSnackbar) {
              this.unpaidSnackbar = true;
            }
          }

          return response.data.success;
        } else {
          response.data.success;
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>